/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import './AccountOwners.scss';

import React, { Fragment } from 'react';

const AccountOwners = ({ account, delimiter }) => {
  if (!account) {
    return null;
  }
  const owners = account.owners;
  return (
    <div className="account-owners">
      {owners.map((owner, i) => {
        return (
          <Fragment key={i}>
            <span className={'owner blocked_data'}>{owner.ownerName}</span>
            {i !== owners.length - 1 ? delimiter : null}
          </Fragment>
        );
      })}
    </div>
  );
};

export default AccountOwners;
